import React, { useState } from "react";
import { connect } from "react-redux";
import { STATE_CHOICES } from "./stateChoice";
import { Button, Alert } from "react-bootstrap";
import axios from "axios";
import { API } from "../../api";

function AddProfile(props) {
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [state, setState] = useState("");
  const [landmark, setLandmark] = useState("");
  const [error, setError] = useState(null);

  const myError = (msg) => {
    setError(`${msg}`);
    setTimeout(() => {
      setError(null);
    }, 2000);
  };
  const handelValidate = () => {
    if (
      fname.trim().length === 0 ||
      lname.trim().length === 0 ||
      String(phone).trim().length === 0 ||
      address.trim().length === 0 ||
      city.trim().length === 0 ||
      String(zipcode).trim().length === 0 ||
      state === "Select State"
    ) {
      myError("Please Fill In All The Fields");
      return false;
    }

    if (String(phone).trim().length !== 10) {
      myError("Phone Number Should Be OF 10 Digit");
      return false;
    }

    let check_phone = String(phone).split("");
    let check_err = false;
    check_phone.forEach((item) => {
      if (isNaN(item)) {
        check_err = true;
      }
    });
    if (check_err) {
      myError("Phone Number Should Include Only Number");
      return false;
    }

    // const pat = new RegExp(/^[a-zA-Z ]{3,30}$/);
    // if (!pat.test(fname)) {
    //   myError("3-20");
    // }
    return true;
  };

  const handelSubmit = (e) => {
    e.preventDefault();
    if (handelValidate()) {
      const data = {
        first_name: fname,
        last_name: lname,
        phone,
        address,
        city,
        zipcode,
        state,
        landmark,
      };
      if (props.token) {
        axios
          .post(`${API}addresses/`, data, {
            headers: { Authorization: `Bearer ${props.token}` },
          })
          .then((res) => {
            myError("Address Added Successfully !!!");
            setFname("");
            setLname("");
            setPhone("");
            setAddress("");
            setCity("");
            setZipcode("");
            setState("");
            setLandmark("");
          })
          .catch((err) => {
            console.log(err.response.data);
          });
      }
    }
  };

  return (
    <div className="container">
      <div className="mt-md-2">
        <p> Add Your Profile Here</p>
      </div>
      <form onSubmit={handelSubmit}>
        <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control"
            id="floatingInput1"
            placeholder="First Name"
            value={fname}
            onChange={(e) => {
              setFname(e.target.value);
            }}
          />
          <label htmlFor="floatingInput1">First Name</label>
        </div>
        <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control"
            id="floatingInput2"
            placeholder="Last Name"
            value={lname}
            onChange={(e) => {
              setLname(e.target.value);
            }}
          />
          <label htmlFor="floatingInput2">Last Name</label>
        </div>
        <div className="form-floating mb-3">
          <input
            type="number"
            className="form-control"
            id="floatingInput3"
            placeholder="Phone"
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value);
            }}
          />
          <label htmlFor="floatingInput3">Phone</label>
        </div>
        <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control"
            id="floatingInput4"
            placeholder="Address"
            value={address}
            onChange={(e) => {
              setAddress(e.target.value);
            }}
          />
          <label htmlFor="floatingInput4">Address</label>
        </div>
        <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control"
            id="floatingInput9"
            placeholder="Address"
            value={landmark}
            onChange={(e) => {
              setLandmark(e.target.value);
            }}
          />
          <label htmlFor="floatingInput9">Landmark</label>
        </div>
        <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control"
            id="floatingInput5"
            placeholder="City"
            value={city}
            onChange={(e) => {
              setCity(e.target.value);
            }}
          />
          <label htmlFor="floatingInput5">City</label>
        </div>
        <div className="form-floating mb-3">
          <input
            type="number"
            className="form-control"
            id="floatingInput6"
            placeholder="Zipcode"
            value={zipcode}
            onChange={(e) => {
              setZipcode(e.target.value);
            }}
          />
          <label htmlFor="floatingInput6">Zipcode</label>
        </div>
        <div className="form-floating mb-3">
          <select
            className="form-control"
            placeholder="Select State"
            id="floatingInput7"
            onClick={(e) => {
              setState(e.target.value);
            }}
          >
            <option defaultValue={true}>Select State</option>
            {STATE_CHOICES.map((item, i) => {
              return (
                <option key={i} value={item[0]}>
                  {item[1]}
                </option>
              );
            })}
          </select>
          <label htmlFor="floatingInput7">Select State</label>
        </div>
        <div>
          <Button type="submit" variant="primary" className="px-4 w-100">
            Add Profile
          </Button>
          <div className="mt-3">
            {error !== null && <Alert variant="primary">{error}</Alert>}
          </div>
        </div>
      </form>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.userDetails.token ? state.userDetails.token : null,
  };
};

export default connect(mapStateToProps)(AddProfile);
